import React from 'react'
import BaseComponent from './BaseComponent'
import Dropzone from 'react-dropzone'

export default class extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { files: [], imageError: false, preloader: false }
    this._bind('onDrop', 'removeFiles', 'add', 'save')
  }

  onDrop(acceptedFiles) {
    this.setState({
      files: acceptedFiles,
      imageError: false
    })
  }

  removeFiles() {
    this.setState({
      files: []
    })
  }

  add(e) {
    e.preventDefault()

    if(this.state.files.length > 0) {
      this.setState({ preloader: true, imageError: false })
      this.save()
    } else {
      this.setState({ imageError: true })
    }
  }

  save() {
    let data  = {"type" : 'addImages', "params" : {}, "session_id" : this.props.sessionId}
    let formData = new FormData()

    if(typeof(this.state.files) !== "undefined" && this.state.files.length !== 0) {
      if(this.state.files !== undefined){
        if (this.state.files.length > 1) {
          for(var i = 0; i < this.state.files.length; i++) { 
            formData.append('file-'+i, this.state.files[i]) 
          }
        } else if (this.state.files.length === 1) {
          formData.append('file-0', this.state.files[0])
        }
      }
      formData.append('data', JSON.stringify(data))
    } else {
      formData = JSON.stringify(data)
    }

    fetch("/api/app.php", {
      method: "POST",
      body: formData
    })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      if (result.error) {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : result.error}}), true);
      } else {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "green", 'content' : "Pomyślnie dodano zdjęcie."}}), true);
      }
      this.setState({ preloader: false })
      this.props.onImageChange(this.props.name, result.result)
    }, (error) => {
      console.log(error)
      window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : "Coś poszło nie tak"}}), true);
      this.setState({ preloader: false })
    })
  }

  render () {
    let image = this.props.image ? this.props.image[0] : ""

    if(this.state.files[0] !== undefined) {
      image = this.state.files[0].preview
    }

    return (
      <div className="dropzone-holder">
        <Dropzone maxSize={10000000} className={ this.state.imageError ? "dropzone dropzone-reject" : "dropzone" } activeClassName="dropzone-active" rejectClassName="dropzone-reject" multiple={ false } onDrop={ this.onDrop } accept={ "image/*" }>
            {({ isDragActive, isDragReject, acceptedFiles, rejectedFiles }) => {
              if (isDragReject) {
                return <span className="text">To nie jest właściwy format pliku.</span>
              }
              if (isDragActive) {
                return <span className="text">Upuść aby dodać</span>
              }
              return this.state.files.length || image
                ? <div className="contest-image"><img src={ image } alt=""/></div>
                : <span className="text">Dodaj plik<br/><span className="small">Rodzaje plików, które możesz dodać – jpg/gif/png.<br/>Maksymalna waga pliku – 10MB.</span></span>
            }}
          </Dropzone>
          <button className="btn" onClick={ this.add }><span>Upload zdjęcia</span></button>
          { this.state.preloader ? <div className="preloader"><span></span></div> : null }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Dropzone.js